import BaseAPIService from '../base/base-api-service';
import baseModel from 'src/model/base.model';

class ContactService extends BaseAPIService<any> {
  public endpoint: string = '/navapp/v1/contact/send';

  constructor() {
    super(baseModel);
  }

  public sendFeedback(
    comments: string,
    email: string,
    name: string,
    phoneNumber: string,
    accountNumber: string,
    webUserId: string,
    subject: string,
    topic: string
  ): Promise<any> {
    return this.create(`${this.endpoint}`, {
      comments,
      email,
      name,
      phoneNumber: phoneNumber ? phoneNumber : null,
      accountNumber,
      webUserId,
      subject,
      topic
    });
  }
}

const contactServiceInstance = new ContactService();
Object.freeze(contactServiceInstance);

export default contactServiceInstance;
